export enum PurchaseLineStatus {
    PENDING_RECEIPTS_BY_USER = 'PENDING_RECEIPTS_BY_USER',
    UPDATED = 'UPDATED',
    DELETED = 'DELETED',
    ABANDON = 'ABANDON',
    ADDED = 'ADDED'
}
